<template>
	<div
		class="voices-view-skeleton"
		role="presentation"
		aria-label="Loading voices"
	>
		<HYSkeleton
			width="80%"
			height="14px"
			color="strong"
		/>

		<div class="voices-view-skeleton__items">
			<template
				v-for="i in 9"
				:key="i"
			>
				<div class="voices-view-skeleton__item">
					<HYSkeleton
						width="86px"
						height="86px"
						radius="circle"
						color="strong"
					/>
					<HYSkeleton
						width="86px"
						height="14px"
						color="strong"
					/>
				</div>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
import { HYSkeleton } from '@voicemod1/harmony-ui';
</script>

<style scoped lang="scss">
.voices-view-skeleton {
	display: flex;
	flex-direction: column;
	gap: var(--hy-space-md);
	align-items: center;
	justify-content: center;

	height: auto;
	padding-top: var(--hy-space-md);

	&__items {
		display: flex;
		flex-flow: row wrap;
		gap: var(--hy-space-md);
		align-items: center;
		justify-content: center;
	}

	&__item {
		display: flex;
		flex-direction: column;
		gap: var(--hy-space-md);
		align-items: center;
		justify-content: center;
	}
}
</style>
